export default __webpack_public_path__ + "static/media/homs.0bbd5108.jpg";